export class Constants {
  static period_am = "AM";
  static period_pm = "PM";
  static selected_css_class = "selected";
  static open_css_class = "open";
  static data_id_key = "data-id";
  static data_object_id_key = "data-object-id";
  static data_category_id_key = "data-category-id";
  static data_category_name_key = "data-category-name";
  static data_display_id_key = "data-display-id";
  static data_name_key = "data-name";
  static data_username_key = "data-username";
  static data_title_key = "data-title";
  static data_value_key = "data-value";
  static data_units_id_key = "data-units-id";
  static data_units_plural_key = "data-units-plural";
  static data_units_singular_key = "data-units-singular";
  static data_units_abbr_key = "data-units-abbr";
  static data_description_key = "data-description";
  static data_start_key = "data-start";
  static data_end_key = "data-end";
  static data_auto_start_key = "data-auto-start";
  static data_auto_end_key = "data-auto-end";
  static data_min_key = "data-min";
  static data_max_key = "data-max";
  static data_autocomplete_disabled = "data-autocomplete-disabled";
  static key_left = "ArrowLeft";
  static key_right = "ArrowRight";
  static key_up = "ArrowUp";
  static key_down = "ArrowDown";
  static key_enter = "Enter";
  static key_escape = "Escape";
}